import React, { useEffect, useRef } from 'react';
import './Stats.css';

const Stats = () => {
  const statsRef = useRef(null);

  const countUp = (element, target) => {
    let v = 0;
    const s = Math.ceil(target / 50);
    const suffix = element?.dataset.suffix ?? '+';
    const iv = setInterval(() => {
      v = Math.min(v + s, target);
      if (element) {
        element.textContent = v + suffix;
      }
      if (v >= target) clearInterval(iv);
    }, 28);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const statNumbers = entry.target.querySelectorAll('[data-count]');
            statNumbers.forEach((num) => {
              countUp(num, parseInt(num.dataset.count));
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );

    if (statsRef.current) {
      observer.observe(statsRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className="stats-section" id="about">
      <div className="stats-inner">
        <div className="stats-grid" ref={statsRef}>
          <div className="stat-box reveal">
            <div className="stat-num" data-count="2500" data-suffix="+">0</div>
            <div className="stat-label">Students Guided</div>
          </div>
          <div className="stat-box reveal">
            <div className="stat-num" data-count="98" data-suffix="%">0</div>
            <div className="stat-label">% Success Rate</div>
          </div>
          <div className="stat-box reveal">
            <div className="stat-num" data-count="60" data-suffix="+">0</div>
            <div className="stat-label">Partner Universities</div>
          </div>
          <div className="stat-box reveal">
            <div className="stat-num" data-count="6" data-suffix="+">0</div>
            <div className="stat-label">Years of Excellence</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Stats;